export var altNamesTranslations = {
    PREVIOUS: {
        id: "ui-br-publishers.publishers.alternativeNames.type.previous",
    },
    IMPRINT: {
        id: "ui-br-publishers.publishers.alternativeNames.type.imprint",
    },
    ABBREVIATION: {
        id: "ui-br-publishers.publishers.alternativeNames.type.abbreviation",
    },
    ORGANIZATION_UNIT: {
        id: "ui-br-publishers.publishers.alternativeNames.type.organizationUnit",
    },
    FOREIGN_LANGUAGE: {
        id: "ui-br-publishers.publishers.alternativeNames.type.foreignLanguage",
    },
};
export var getAltNameTranslation = function (intl, key) {
    var translation = altNamesTranslations[key];
    if (!translation)
        return key;
    return intl.formatMessage(translation);
};
